import React, { useEffect, useState } from 'react';
import './SearchBox.css'; 
import '../../common/CommonText.css';

const SearchBox = ({ categories, onSearchSelect,defaultValue }) => {
  const [searchTerm, setSearchTerm] = useState('defaultValue');
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  // const handleInputChange = (e) => {
  //   const value = e.target.value;
  //   setSearchTerm(value);
  //   setIsDropdownVisible(value.length > 0);
  // };
  // const handleInputChange = (e) => {
  //   const value = e.target.value;
  //   setSearchTerm(value);
  //   setIsDropdownVisible(value.length > 0);
    
  //   if (value === '') {
  //     onSearchSelect('', '');
  //   }
  //   };

  const handleCategoryClick = (category) => {
    onSearchSelect(category, searchTerm); 
    setIsDropdownVisible(false);
  };
  useEffect(() =>{
    setSearchTerm(defaultValue);
    },[defaultValue])
    
    const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setIsDropdownVisible(value.length > 0);

    if (value === '') {
      onSearchSelect('', '');
    }
    };
  return (
    <div className="search-box-container">
      <div className="search-input-wrapper">
        <svg className="search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.8889 11.8889L15 15M1 7.22222C1 8.87246 1.65555 10.4551 2.82245 11.622C3.98934 12.7889 5.57199 13.4444 7.22222 13.4444C8.87246 13.4444 10.4551 12.7889 11.622 11.622C12.7889 10.4551 13.4444 8.87246 13.4444 7.22222C13.4444 5.57199 12.7889 3.98934 11.622 2.82245C10.4551 1.65555 8.87246 1 7.22222 1C5.57199 1 3.98934 1.65555 2.82245 2.82245C1.65555 3.98934 1 5.57199 1 7.22222Z" stroke="#424242" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>        </svg>


        <input
          className="search-box common-text fts-15 ftw-4 lt-gray"
          placeholder="Search"
          value={searchTerm}
          onChange={handleInputChange}
        />
      </div>

      {isDropdownVisible && (
        <div className="search-dropdown">
          {categories.map((category, index) => (
            <div
              key={index}
              className="search-dropdown-item fts-12"
              onClick={() => handleCategoryClick(category)}
            >
              Search <strong> {category} </strong> for: <span className="search-term"> { searchTerm } </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBox;
